<span matSnackBarLabel>
  {{ text | translate }}
</span>
<span matSnackBarActions>
  <button mat-button matSnackBarAction (click)="close()">
    {{ "components.info-snackbar.close" | translate }}
  </button>
</span>
